import { render, staticRenderFns } from "./scroll_product.vue?vue&type=template&id=1e4abce3&scoped=true"
import script from "./scroll_product.vue?vue&type=script&lang=js"
export * from "./scroll_product.vue?vue&type=script&lang=js"
import style0 from "./scroll_product.vue?vue&type=style&index=0&id=1e4abce3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4abce3",
  null
  
)

export default component.exports